import { menuselect } from "@/constant/menuselect";
let str = "全面绩效管理";
export const config = {
  title: "绩效考核管理",
  headerInfo:
    "按照医院管理现状和需求，制定医院运营改善的目标和措施，结合信息化建设方案，制定医院绩效管理方案。",
  headerImg: require("@/assets/images/Performance/overall/topimg.png"),
  activeTitle:str,
  activeSubTitle: str,

  navList: [
    {
      name: "绩效考核管理",
      children: menuselect(),
    },

    {
      name: "全面绩效管理",
      desc: "全面绩效管理是基于现代医院管理中需要解决的内部管理与外部竞争，形成的一套以绩效管理为中心，包含医院问题梳理、管理内容的梳理、管理目标制定、管理任务执行、管理结果奖惩，一整套全面的解决方案。敬在信息通过对医院业务深层次的场景分析，建立以“患者为中心”，以“投入为资源”场景化绩效模式，针对患者在院期间，人员投入的不同时间、不同患者、不同地点，建立不同的绩效核算标准，真正意义上将医院的绩效导向细化到事项，让绩效起到“指挥棒”的作用。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/Performance/overall/1094one1.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/Performance/overall/1095one2.png"),
        },
        {
          title: "分配原则",
          desc: "建立健全符合医疗行业特点、体现岗位绩效和医务人员技术服务价值的绩效分配制度。加强绩效考核，服务质量、效率和患者满意度为核心的内部分配机制，通过多劳多得、优绩优酬，体现医务人员技术服务价值。充分考虑医院现状制定绩效管理标准，保障绩效落到实处。",
          img: require("@/assets/images/Performance/overall/1096one3.png"),
        },
        {
          title: "应用价值",
          desc: " ",
          img: require("@/assets/images/Performance/overall/1097one4.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/Performance/overall/1099one5.png"),
        },
      ],
    },
    {
      name: "绩效二级分配",
      desc: "进一步推动医院可持续发展，建立有责任、有纪律、有激励、有竞争、有约束，充满生机和活力的内部运营机制，充分调动每位职工的积极性，方便各科室内部二次考核分配。",
      tabList: [{}],
      [str]: [
        {
          title: "指导原则",
          desc: "建立健全符合医疗行业特点、体现岗位绩效和医务人员技术服务价值的绩效分配制度。加强绩效考核，服务质量、效率和患者满意度为核心的内部分配机制，通过多劳多得、优绩优酬，体现医务人员技术服务价值。充分考虑医院现状制定绩效管理标准，保障绩效落到实处。",
          img: require("@/assets/images/Performance/overall/1095two1.png"),
        },

        {
          title: "分配原则及二次分配讲解",
          desc: " ",
          img: require("@/assets/images/Performance/overall/1101two2.png"),
        },
      ],
    },

    {
      name: "疾病能力绩效",
      desc: "场景价值的绩效方案，是为了应对医院在绩效管理维度中“人文”因素的重要体现，针对相同事项，在以“时间”、“地点”、“患者”、“科室” 等因素中，综合构不同的绩效价值的解决方案。依托精细化场景核算模式，对不同场景，建立不同的绩效价值策略，充分体系向知识价值、劳动价值、公益价值为导向的分配政策。明确科室运营成本，以“管理”为核心的导向，鼓励科室有效控制成本、有效管理成本，减少科室不能通过行为控制而强压的无效管理行为。改变行政后勤大锅饭的模式，通过对岗位的价值评估，建立以岗位系数、科室系数为基础的院内行政分配体系。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/Performance/overall/1100three1.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/Performance/overall/1103three2.png"),
        },
      ],
    },
  ],
};
